<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex align-items-center gap-3">
          <h2 class="mb-0">{{ clientName }}</h2>
          @if (loading) {
            <jni-spinner></jni-spinner>
          }
        </span>
        <span class="d-flex gap-2 align-items-center">
          <p-button
            label="Create New"
            icon="pi pi-plus"
            (click)="openCreateModal()" />
          <span
            *ngIf="clientIdInput"
            class="cross-border"
            (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          [stripedRows]="true"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [scrollable]="groupDetails.length > 0"
          [scrollHeight]="
            groupDetails.length > 0 ? 'calc(100vh - 310px)' : undefined
          "
          [size]="'small'"
          [value]="groupDetails"
          [totalRecords]="totalRecords"
          [lazy]="true"
          [rows]="rows"
          (onLazyLoad)="loadGroups($event)"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="groupDetails.length > 0"
          [filterDelay]="0"
          paginatorStyleClass="paginator-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [styleClass]="
            groupDetails.length > 0
              ? 'table-listing'
              : 'table-listing no-data-table'
          ">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th pSortableColumn="groupName">
                Project Access Group Name
                <p-sortIcon field="groupName"></p-sortIcon>
              </th>
              <th pSortableColumn="userCount">
                Users
                <p-sortIcon field="userCount"></p-sortIcon>
              </th>
              <th pSortableColumn="createdDate">
                Created
                <p-sortIcon field="createdDate"></p-sortIcon>
              </th>
              <th pSortableColumn="isEnabled">
                Status
                <p-sortIcon field="isEnabled"></p-sortIcon>
              </th>
            </tr>
            <tr class="sort-row">
              <th>
                <input
                  pInputText
                  type="text"
                  autocomplete="off"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'groupName',
                      'contains'
                    )
                  "
                  (paste)="$event.stopPropagation()"
                  placeholder="search"
                  class="p-column-filter" />
              </th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="loadingbody">
            <tr style="height: 46px">
              <td><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <a
                  class="group-name-link pointer"
                  role="button"
                  tabindex="0"
                  (click)="openUpdateModal(item)"
                  (keydown.enter)="openUpdateModal(item)"
                  (keydown.space)="
                    $event.preventDefault(); openUpdateModal(item)
                  ">
                  {{ item.groupName }}
                </a>
              </td>
              <td>
                <span class="user-badge">{{ item.userCount }} Users</span>
              </td>
              <td>{{ item.createdDate | date: "MM-dd-yyyy" }}</td>
              <td class="form-switch-hgt" (click)="$event.stopPropagation()">
                <div class="form-check form-switch m-0">
                  <p-toggleswitch
                    [formControl]="item.enabledControl"
                    (onChange)="onToggleChange(item, $event.checked)"
                    class="toggle-switch"></p-toggleswitch>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading">
              <td colspan="4" class="no-data-cell border-0">
                <div
                  class="d-flex align-items-center justify-content-center flex-column text-center h-100 w-100">
                  <span class="no-data-image d-block w-25 h-25 mb-4"></span>
                  <h3 class="fs-5 fw-medium mb-2">No Data found</h3>
                  <p>
                    It seems we couldn't locate any information at this time.<br />
                    Please check back later or try a different search.
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<!-- Create Group Modal -->
<jni-create-group-modal
  [visible]="showCreateModal"
  [customerAccount]="clientId"
  (visibleChange)="showCreateModal = $event"
  (groupCreated)="onGroupCreated()">
</jni-create-group-modal>

<!-- Update Group Modal -->
<jni-update-group-modal
  [visible]="showUpdateModal"
  [group]="selectedGroup"
  [customerAccount]="clientId"
  (visibleChange)="showUpdateModal = $event"
  (groupUpdated)="onGroupUpdated()">
</jni-update-group-modal>

<!-- Disable-group confirmation -->
@if (showDisableConfirm) {
  <jni-confirm-dialog
    headerMsg="Disable Group"
    [dialogMessage]="disableConfirmMessage"
    (confirmDialogStatus)="onDisableConfirmStatus($event)">
  </jni-confirm-dialog>
}
